var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "25px",
    viewBox: "0 0 21 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "combined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aspera-19-(35)",
    transform: "translate(-27.000000, -402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "combined",
    transform: "translate(28.000000, 402.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,25 L5.83333333,25 C5.18900113,25 4.66666667,24.5336299 4.66666667,23.9583333 C4.66666667,23.3830367 5.18900113,22.9166667 5.83333333,22.9166667 L17.5,22.9166667 C18.1443322,22.9166667 18.6666667,22.4502966 18.6666667,21.875 L18.6666667,7.11458333 C18.6684596,6.83770522 18.5467176,6.57158212 18.3283333,6.375 L13.86,2.38541667 C13.639828,2.19043071 13.3417701,2.08173254 13.0316667,2.08333333 L3.5,2.08333333 C2.85566779,2.08333333 2.33333333,2.54970339 2.33333333,3.125 L2.33333333,23.9583333 C2.33333333,24.5336299 1.81099887,25 1.16666667,25 C0.522334459,25 7.89079376e-17,24.5336299 0,23.9583333 L0,3.125 C-2.36723813e-16,1.39911016 1.56700338,3.17040821e-16 3.5,0 L13.0316667,0 C13.9596116,0.0007293835 14.8492523,0.330447969 15.505,0.916666667 L19.9733333,4.90625 C20.6298983,5.49173899 20.9991831,6.28606104 21,7.11458333 L21,21.875 C21,23.6008898 19.4329966,25 17.5,25 Z",
    id: "Delete",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dollar-sign",
    transform: "translate(7.241379, 7.857143)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4256
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8512931,0 L2.8512931,10",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31034486,2.14285714 L1.68965518,2.14285714 C0.756484393,2.14285714 0,2.86239951 0,3.75 C0,4.63760049 0.756484393,5.35714286 1.68965518,5.35714286 L4.1034483,5.35714286 C5.03661908,5.35714288 5.79310345,6.07668524 5.79310345,6.96428571 C5.79310345,7.85188619 5.03661908,8.57142855 4.1034483,8.57142857 L0,8.57142857",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.b317c14cb30018f0d1bf14309124df1e.svg";
export { ForwardRef as ReactComponent };